import { isObservableArray } from 'mobx';

interface Column {
    data: ColumnData | Array<ColumnData>;
}

interface ColumnData {
    property: string;
    code: string;
    index: number;
    key: string;
    sortKey: string;
    sortable: boolean;
}

// Returns a column object for the first sortable column when column.data is an array of multiple data points
// Return the column by default, which may or may not be sortable
export const getSortableColumn = (column: Column) => {
    const { data } = column;

    if (isObservableArray(data)) {
        column = {
            ...column,
            data: data.find(c => c.sortable),
        };
    }

    return column;
};

export default getSortableColumn;



// WEBPACK FOOTER //
// ./src/utils/getSortableColumn.ts